import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchUserById = createAsyncThunk('getUserById/fetchUserById',
  async (id, { rejectWithValue }) => {
    try {
      const url = `${api.getUserById}${id}`;
      const response = await axiosPrivate.get(url)
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server")
    }
  })

const getUserByIdSlice = createSlice({
  name: 'User',
  initialState: {
    User: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchUserById.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchUserById.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.User = action.payload;
        })
      .addCase(fetchUserById.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        });
  }
})

export default getUserByIdSlice.reducer;